import React, { useEffect, useState } from 'react'
import { Table, Card, Button, InputNumber, Modal, Form, Input, message, Space } from 'antd'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import { listUsers, adjustCoins, User } from '../../api/admin'

const Users: React.FC = () => {
  const [users, setUsers] = useState<User[]>([])
  const [loading, setLoading] = useState(true)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedUser, setSelectedUser] = useState<User | null>(null)
  const [form] = Form.useForm()

  useEffect(() => {
    loadUsers()
  }, [])

  const loadUsers = async () => {
    try {
      const data = await listUsers({ page: 1, page_size: 100 })
      setUsers(data)
    } catch {
      // 错误已在拦截器中处理
    } finally {
      setLoading(false)
    }
  }

  const handleAdjustCoins = (user: User) => {
    setSelectedUser(user)
    setModalVisible(true)
    form.resetFields()
  }

  const handleAdjustSubmit = async () => {
    try {
      const values = await form.validateFields()
      if (!selectedUser) return

      await adjustCoins(selectedUser.id, values.amount, values.reason)
      message.success('调整成功')
      setModalVisible(false)
      loadUsers()
    } catch {
      // 表单验证失败
    }
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80
    },
    {
      title: '昵称',
      dataIndex: 'nickname',
      key: 'nickname'
    },
    {
      title: 'OpenID',
      dataIndex: 'openid',
      key: 'openid',
      ellipsis: true,
      width: 200
    },
    {
      title: '审批币',
      dataIndex: 'coins',
      key: 'coins',
      render: (coins: number) => (
        <span style={{ fontWeight: 'bold', color: '#faad14' }}>
          🪙 {coins}
        </span>
      )
    },
    {
      title: '邀请码',
      dataIndex: 'invite_code',
      key: 'invite_code'
    },
    {
      title: '注册时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date: string) => new Date(date).toLocaleString('zh-CN')
    },
    {
      title: '操作',
      key: 'action',
      render: (_: unknown, record: User) => (
        <Space>
          <Button
            type="link"
            icon={<PlusOutlined />}
            onClick={() => {
              form.setFieldsValue({ amount: 100 })
              handleAdjustCoins(record)
            }}
          >
            加币
          </Button>
          <Button
            type="link"
            danger
            icon={<MinusOutlined />}
            onClick={() => {
              form.setFieldsValue({ amount: -100 })
              handleAdjustCoins(record)
            }}
          >
            扣币
          </Button>
        </Space>
      )
    }
  ]

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>👥 用户管理</h2>

      <Card>
        <Table
          columns={columns}
          dataSource={users}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 20 }}
        />
      </Card>

      <Modal
        title={`调整 ${selectedUser?.nickname} 的审批币`}
        open={modalVisible}
        onOk={handleAdjustSubmit}
        onCancel={() => setModalVisible(false)}
        okText="确认"
        cancelText="取消"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="amount"
            label="调整数量"
            rules={[{ required: true, message: '请输入调整数量' }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder="正数为加币，负数为扣币"
            />
          </Form.Item>
          <Form.Item
            name="reason"
            label="原因"
          >
            <Input.TextArea placeholder="请输入原因" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default Users
